<template>
	<div style="width:100%;height:100%;">
		<div style="display: flex;justify-content: center;align-items: center;margin-top:20px;">
			<div style="display: flex;background-color:white;padding-top:34px;width: 1230px;padding-bottom:57px;">
				<div style="display: flex;margin-left:88px;">
					<div>
						<div class="font" style="text-align: left;font-weight:bold;">产品中心</div>
						<div style="display: flex;margin-top:14px;">
							<div style="width:27px;height: 3px;background-color: #5AD6CE;"></div>
							<div style="width:27px;height: 3px;background-color: #38A5EC;"></div>
						</div>
						<div v-for="(item,index) in datalis" :key="index">
							<a :href="item.src" target="_blank"><img :src="urls+item.url" class="yxfw"></img></a>
						</div>
					</div>
				</div>
				<div style="display: flex;margin-left:100px;">
					<div style="padding-bottom: 30px;">
						<div class="font" style="text-align: left;font-weight:bold;opacity:0;">11</div>
						<div style="display: flex;margin-top:14px;">
							<div style="width:27px;height: 3px;"></div>
							<div style="width:27px;height: 3px;"></div>
						</div>
						<div v-for="(item,index) in datali" :key="index">
							<a :href="item.src" target="_blank"><img :src="urls+item.url" class="yxfw"></img></a>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		userRejister
	} from "../util/api.js";
	import axios from '../util/http.js'
	import base from '../util/base.js'
	export default {
		name: "Business",
		components: {},
		data() {
			return {
				datalis:'',
				datali:'',
				type:1,
				urls: '',
				banners: '',
			}
		},
		created() {
			this.$store.commit("meetingshow",0)
			this.$store.commit("business",1)
			//轮播图
			userRejister({
				type: this.type
			}).then((res) => {
				if (res) {
					this.banners = res.data
					this.urls = res.url
				}
			})
			//获取商务合作信息接口
			axios({
			    url: `${base.url}/api/user/affairs`,
			    method: 'post',
			    data:''
			}).then((res) => {
				if(res){
					console.log(res);
					this.datalis=res.data.consulting
					this.datali=res.data.marketing
				}
			        })
		},
		methods: {
		},
	}
</script>

<style lang="scss" scoped>
	.zwk {
		margin: 0px 10px 0px 0px;
		width: 348px;
		height: 695px;
		background-color: #ffffff;
	}

	.yxfw {
		width: 477px;
		height: 88px;
		margin-top: 20px;
	}

	.zwk2 {
		width: 1060px;
		height: 695px;
		background-color: #ffffff;
	}

	.buttons {
		background-color: #F4F4F4;
		width: 477px;
		height: 88px;
		border-radius: 5px;
	}

	.color {
		color: #FFFFFF;
		width: 135px;
		height: 42px;
		line-height: 42px;
		text-align: center;
	}

	.serch {
		color: #FFFFFF;
		font-size: 10px;
		background-color: #20919D;
		text-align: center;
		height: 31px;
		line-height: 31px;
		width: 50px;
	}

	.flex {
		display: flex;
	}

	.flexjust {
		justify-content: center;
	}

	.flexali {
		align-items: center;
	}

	.colorwhite {
		color: #FFFFFF;
	}

	.dhl {
		color: #FFFFFF;
		font-size: 15px;
		justify-content: center;
		align-items: center;
		padding: 0 20px;
	}

	.dhls {
		color: #FFFFFF;
		font-size: 15px;
		background-color: #59D4CF;
		display: flex;
		justify-content: center;
		align-items: center;
		padding: 0 20px;
	}

	.Line {
		width: 1px;
		height: 14px;
		background-color: #FFFFFF;
	}

	.font {
		font-size: 14px;
	}

	.por {
		display: flex;
		flex-direction: column;
		margin-left: 10px;
	}

	.bodya {
		background-color: #5AD6CE;
		width: 100px;
		height: 86.9px;
		flex-direction: column;
		display: flex;
		justify-content: center;
		align-items: center;
		color: #FFFFFF;
	}

	.iur {
		margin-left: 5px;
	}

	.bjtop {
		margin-top: 10px;
	}

	.bjleft {
		margin-left: 10px;
	}

	.bjright {
		margin-right: 10px;
	}

	.bjbottom {
		margin-bottom: 10px;
	}

	.zxls {
		text-align: left;
		color: #181818;
		font-size: 16px;
	}

	.router-link-active {
		text-decoration: none;
	}

	a {
		text-decoration: none;
	}
</style>
